import { useCallback } from 'react';
import { useRouter } from '@tanstack/react-router';
import Button, { ButtonProps } from 'src/components/ui/Button';
import ArrowLeftIcon from 'src/assets/icons/direction-left.svg';

interface BackButtonProps extends Omit<ButtonProps, 'variant' | 'ghost'> {
  to?: string;
  params?: any;
  hash?: string;
  checkHistory?: boolean;
  isLogin?: boolean;
}

const BackButton = ({
  to = '/',
  checkHistory = false,
  size = 'small',
  isLogin = false,
  hash,
  ...props
}: BackButtonProps) => {
  const { history, navigate } = useRouter();

  const onPress = useCallback(async () => {
    if (isLogin) {
      window.location.replace('https://laddigital.com/');
      return;
    }

    if (checkHistory) history.back();
    else await navigate({ to, hash });
  }, [isLogin, checkHistory, history, navigate, to, hash]);

  return (
    <Button
      {...props}
      onPress={onPress}
      IconLeft={ArrowLeftIcon}
      size={size}
      variant="surface-dark"
      ghost
    >
      Back
    </Button>
  );
};

export default BackButton;
